module.exports = __webpack_public_path__ + "img/icon_token_w.2b4f1433.svg";